const orderStatus = {
	canceled: 'canceled',
	pending: 'pending',
	unshipped: 'unshipped',
	unfulfillable: 'unfulfillable',
	pendingAvailability: 'pending%20availability',
	partiallyShipped: 'partially%20shipped',
	shipped: 'shipped',
};

export { orderStatus };



// WEBPACK FOOTER //
// ./src/common/constants/orderStatusConstants.js